<template lang="pug">
form#article-form(
  name="article-form"
  @submit.prevent="submit"
  novalidate
)
  .modal-card
    header.modal-card-head
      p.modal-card-title Publish Article
    section.modal-card-body.modal-tabs
      b-tabs(
        position="centered"
        :animated="false"
        expanded
      )
        b-tab-item(label="Details")
          b-field(label="Publish" expanded)
          b-field(grouped)
            b-field
              b-switch(
                type="is-success"
                :value="article.is_published"
                @input="set($event, 'is_published')"
              )
            b-field(v-if="article.is_published" expanded)
              b-datepicker(
                :value="article.pub_date"
                @input="set($event, 'pub_date')"
              )
          b-field(label="Title")
            b-input(
              :value="article.title"
              @input="set($event, 'title')"
            )
          b-field(label="Author")
            elasticsearch-multiselect(
              :value="article.author_id"
              :maxtags="1"
              :allow-new="false"
              placeholder="Search staff members..."
              field="full_name"
              icon="account-circle"
              index="doxa_staff_members"
              @input="setAuthor($event, 'author_id')"
            )
          b-field(label="Preview")
            b-input(
              type="textarea"
              rows="3"
              :value="article.short_desc"
              @input="set($event, 'short_desc')"
            )
          b-field(label="Tags")
            elasticsearch-multiselect(
              :value="article.tag_ids"
              :allow-new="true"
              field="label"
              icon="tag"
              index="doxa_tags"
              placeholder="Search by tag..."
              @add="addTag"
              @input="set($event, 'tag_ids')"
            )
          b-field(label="Comments")
            b-switch(
              type="is-success"
              :value="article.comments_enabled"
              @input="set($event, 'comments_enabled')"
            )
        b-tab-item(label="Artwork")
          cover-art-tab(
            v-model="artwork"
            :default-image="defaultArtwork"
            @input="img => artwork = img"
          )
    footer.modal-card-foot
      button.button(
        type="submit"
        :class="{ 'is-success': article.is_published, 'is-primary': !article.is_published, 'is-loading': settings.submitting }"
      ) {{ saveLabel }}
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import CoverArtTab from '@/components/form/episode/CoverArtTab';
import ElasticsearchMultiselect from '@/components/form/ElasticsearchMultiselect';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'article-form',
  components: {
    CoverArtTab,
    ElasticsearchMultiselect,
  },
  computed: {
    ...mapGetters({
      article: getters.GET_ARTICLE_EDITING,
    }),
    defaultArtwork() {
      if (this.article._embedded.artwork) {
        return this.article._embedded.artwork.file.url;
      }
      return null;
    },
    saveLabel() {
      return this.article.is_published ? 'Publish Article' : 'Save Draft';
    },
  },
  created() {
    if (!this.article.pub_date) {
      this.$store.commit(mutations.SET_ARTICLE_EDITING_FIELD, {
        key: 'pub_date',
        val: new Date(),
      });
    }
  },
  data() {
    return {
      artwork: null,
      settings: {
        submitting: false,
      },
    };
  },
  methods: {
    async addTag(val) {
      if (typeof (val) === 'string') {
        const payload = {
          label: val,
        };
        const { data } = await this.$store.dispatch(actions.DO_CREATE_TAG, payload);
        const index = _.indexOf(this.article.tag_ids, val);
        this.$store.commit(mutations.SET_ARTICLE_EDITING_TAG_AT_INDEX, {
          index,
          val: data.tags[0].id,
        });
      }
    },
    set(val, key) {
      this.$store.commit(mutations.SET_ARTICLE_EDITING_FIELD, {
        key,
        val,
      });
    },
    setAuthor(val, key) {
      this.$store.commit(mutations.SET_ARTICLE_EDITING_FIELD, {
        key,
        val: val[0],
      });
    },
    async submit() {
      const validate = await this.$validator.validateAll();
      if (validate) {
        this.settings.submitting = true;
        const payload = {
          id: this.article.id,
          author_id: this.article.author_id,
          body: this.article.draft_body,
          comments_enabled: this.article.comments_enabled,
          is_published: this.article.is_published,
          pub_date: moment(this.article.pub_date).format('YYYY-MM-DD'),
          short_desc: this.article.short_desc,
          tag_ids: this.article.tag_ids.join(','),
          title: this.article.title,
          zoom: 'artwork',
        };
        if (this.artwork) {
          const file = this.artwork.generateDataUrl('image/jpeg');
          const { data } = await this.$store.dispatch(actions.DO_CREATE_MEDIA_IMAGE, { file });
          payload.artwork_id = data.images[0].id;
        }
        try {
          const response = await this.$store.dispatch(actions.DO_UPDATE_ARTICLE, payload);
          this.$parent.close();
          this.$store.commit(mutations.SET_APP_SNACKBAR, {
            type: 'is-success',
            message: response.message,
          });
          this.settings.submitting = false;
        } catch (error) {
          this.settings.submitting = false;
          this.$store.commit(mutations.SET_APP_SNACKBAR, {
            type: 'is-danger',
            message: error.response.data.data.error_message,
          });
        }
      }
    },
  },
};
</script>

<style lang="scss">
#article-form {
  .modal-card-body {
    min-height: 26rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/article/ArticleForm.vue